import { defineMessages } from 'react-intl';

export const buyerBenefits = defineMessages({
    vetted: {
        id: 'pdp.buyerAssurance.buyer.benefit.vetted',
        defaultMessage: 'Only Vetted, Professional Sellers',
    },
    protection: {
        id: 'pdp.buyerAssurance.buyer.benefit.protection',
        defaultMessage: 'Buyer Protection Guaranteed',
    },
    delivery: {
        id: 'pdp.buyerAssurance.buyer.benefit.delivery',
        defaultMessage: 'Fully Insured Global Deliveries',
    },
});

export const tradeBenefits = defineMessages({
    vetted: {
        id: 'pdp.buyerAssurance.trade.benefit.vetted',
        defaultMessage: 'Only Vetted, Professional Sellers',
    },
    protection: {
        id: 'pdp.buyerAssurance.trade.benefit.protection',
        defaultMessage: 'Buyer Protection Guaranteed',
    },
    delivery: {
        id: 'pdp.buyerAssurance.trade.benefit.delivery',
        defaultMessage: 'Fully Insured Global Deliveries',
    },
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/BuyerAssurance/buyerAssuranceMessage.es.js